<template>
  <div
    ref="container"
    class="frc-captcha"
    :data-sitekey="friendlyCaptchaSitekey"
    :data-start="start"
    :data-lang="lang"
    :data-puzzle-endpoint="friendlyCaptchaPuzzleEndpoint"
  />
</template>

<script setup lang="ts">
import { onMounted, onUnmounted, ref } from "vue";
import { WidgetInstance } from "friendly-challenge";
import { useDeployementInfoStore } from "~/stores/deploymentinfostore";

const deployementInfoStore = useDeployementInfoStore();
const friendlyCaptchaSitekey = computed(
  () => deployementInfoStore.deploymentInfo?.friendlyCaptchaSitekey,
);
const friendlyCaptchaPuzzleEndpoint = computed(
  () => deployementInfoStore.deploymentInfo?.friendlyCaptchaPuzzleEndpoint,
);

const props = defineProps<{
  start?: "auto" | "focus" | "none";
  lang?: string;
}>();

const emit = defineEmits<{
  (e: "complete", solution: string): void;
  (e: "error", error: unknown): void;
  (e: "reset"): void;
}>();

const container = ref<HTMLElement | null>(null);
const widget = ref<WidgetInstance | null>(null);

onMounted(() => {
  if (!container.value) return;

  widget.value = new WidgetInstance(container.value, {
    startMode: props.start ?? "focus",
    doneCallback: (solution: string) => {
      emit("complete", solution);
    },
    errorCallback: (err: unknown) => {
      emit("error", err);
    },
  });
});

onUnmounted(() => {
  if (widget.value) {
    widget.value.destroy();
    widget.value = null;
  }
});

// optional manual reset from parent
const reset = () => {
  widget.value?.reset();
  emit("reset");
};

defineExpose({ reset });
</script>
<style>
.frc-captcha {
  max-width: none !important;
}
</style>
